/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Athletic_Performance_TermsInputs */

const en_service_type_athletic_performance_terms = /** @type {(inputs: Service_Type_Athletic_Performance_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`strength and conditioning, speed, agility, athlete, preseason, sports performance`)
};

const pl_service_type_athletic_performance_terms = /** @type {(inputs: Service_Type_Athletic_Performance_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`motoryka, przygotowanie do sezonu, szybkość, skoczność, zawodnik, sportowiec, piłka nożna`)
};

/**
* | output |
* | --- |
* | "strength and conditioning, speed, agility, athlete, preseason, sports performance" |
*
* @param {Service_Type_Athletic_Performance_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_athletic_performance_terms = /** @type {((inputs?: Service_Type_Athletic_Performance_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Athletic_Performance_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_athletic_performance_terms(inputs)
	return en_service_type_athletic_performance_terms(inputs)
});